import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetSubscriptionAll } from "../../domain/usecases/getSubscriptionAll";
import { CreateSubscriptionWithPaypal, CreateSubscriptionWithPaypalParams } from "../../domain/usecases/createSubscriptionWithPaypal";
import { GetSubscriptionByUser } from "../../domain/usecases/getSubscriptionByUser"; 
import { CancelSubscriptionWithPaypal } from "../../domain/usecases/cancelSubscriptionWithPaypal";

export const onGetSubscriptionAll = createAsyncThunk(
	"subscription/all",
	async (_, { extra }) => {
		const { getSubscriptionAll } = extra as {
			getSubscriptionAll: GetSubscriptionAll;
		};
		const result = await getSubscriptionAll.execute();
		return result;
	}
);

export const onCreateSubscriptionWithPaypal = createAsyncThunk(
	"subscription/create-suscription-paypal",
	async (params: CreateSubscriptionWithPaypalParams, { extra }) => {
		const { createSubscriptionWithPaypal } = extra as {
			createSubscriptionWithPaypal: CreateSubscriptionWithPaypal;
		};
		const result = await createSubscriptionWithPaypal.execute(params);
		return result;
	}
);

export const onGetSubscriptionByUser = createAsyncThunk(
	"subscription/by-user",
	async (_, { extra }) => {
		const { getSubscriptionByUser } = extra as {
			getSubscriptionByUser: GetSubscriptionByUser;
		};
		const result = await getSubscriptionByUser.execute();
		return result;
	}
);

export const onCancelSubscriptionWithPaypal = createAsyncThunk(
	"subscription/cancel-suscription-paypal",
	async (_, { extra }) => {
		const { cancelSubscriptionWithPaypal } = extra as {
			cancelSubscriptionWithPaypal: CancelSubscriptionWithPaypal;
		};
		await cancelSubscriptionWithPaypal.execute();
		return;
	}
);
